import { Module } from 'vuex';

import tool from '@/utils/tool';
import RootModuleTypes from '@/store/interface';
import ProjectModuleTypes from '@/store/modules/middleGround/investment/project/interface';

const projectModule: Module<ProjectModuleTypes, RootModuleTypes> = {
    namespaced: true,
    state: {
        projectId: '',
    },
    mutations: {
        projectId(state, projectId){
            state.projectId = projectId;
        },
    },
    actions: {
        setProjectId(context, projectId){
            context.commit('projectId', projectId);
        },
        pageProjectList(context, searchParams) {
            return new Promise((resolve, reject) => {
                tool.post("/middle/project/pageProjectList", searchParams).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        saveProject(context, searchParams) {
            return new Promise((resolve, reject) => {
                tool.post("/middle/project/saveProject", searchParams).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        listHouseNature(context, searchParams) {
            return new Promise((resolve, reject) => {
                tool.post("/middle/project/listHouseNature", searchParams).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        listDecorateType(context, searchParams) {
            return new Promise((resolve, reject) => {
                tool.post("/middle/project/listDecorateType", searchParams).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        listCompanyArea(context, searchParams) {
            return new Promise((resolve, reject) => {
                tool.post("/middle/project/listCompanyArea", searchParams).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        getProject(context, searchParams) {
            return new Promise((resolve, reject) => {
                tool.post("/middle/project/getProject", searchParams).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        listHouseProperty(context, searchParams) {
            return new Promise((resolve, reject) => {
                tool.post("/middle/project/listHouseProperty", searchParams).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        deleteProject(context, searchParams) {
            return new Promise((resolve, reject) => {
                tool.post("/middle/project/deleteProject", searchParams).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        
        
    },
};

export default projectModule;